export const SET_TRANSACTIONS = "SET_TRANSACTIONS";
export const GET_TRANSACTIONS = "GET_TRANSACTIONS";
export const REFRESH_TRANSACTIONS = "REFRESH_TRANSACTIONS";